import React from 'react'
import './Warning.css'


export const Warning = () => {
  return (
    <div className="warning">
      <p>
        Bemærk: Dette er en demohjemmeside og ikke en aktiv forretning. 
        Den bruges kun til at vise en portefølje af mine hjemmesider, små pc-programmer 
        og mobil apps, som jeg selv har udviklet.
      </p>
    </div>
  )
}